import Vue from "vue";
import axios from "axios";
import {TokenService} from "../service/token";
import {Message, Loading} from "element-ui";
import {CacheService} from "@/service/common";
import store from "../store/index";

const isNotDev = process.env.NODE_ENV !== "development";

let config = {
    headers: {},
};
let host = window.location.host;
let api;
if (isNotDev) {
    let apiList = host.split(".");
    apiList[0] = "api";
    api = apiList.join(".") + "/api"; // "//api.maidiyun.cn/api"
} else {
    api = host;
}

const request = axios.create(config);

// 获取在线配置的api
export async function getProxy() {
    const {data} = await axios.get(
        `//${api}/Opencloud/SetConfiguration/SetConfigurationList`
    );
    data.data.forEach((d) => {
        config[d.keyName] = d.keyValue; // baseURL fileBaseUrl ssoUrl ossUrl;
        Vue.prototype["$" + d.keyName] = d.keyValue; // $baseURL $fileBaseUrl $ssoUrl $ossUrl;
    });

    Vue.prototype.$logoUrl = config.fileBaseUrl + "x/logos/"; //logo 的 地 址
    Vue.prototype.$localUrl = `//${host}`;
    config.localUrl = `//${host}`;

    let token = TokenService.access();
    if (token) {
        request.defaults.headers.common.Authorization = `Bearer ${token}`;
    }

    let loading = null;
    //token最大刷新次数
    // let MaxRefreshCount = 10
    // const refreshKey = Symbol('re-ref_key');

    request.interceptors.request.use(
        (data) => {
            if (isNotDev) data.baseURL = config.baseURL;
            loading = Loading.service({
                //text: 'Loading',
                background: "transparent",
            });
            // Do something before request is sent
            return data;
        },
        (err) => Promise.reject(err)
    );
    /*是否有请求正在刷新token*/
    let isRefreshing = false;
    let refreshSubscribers = [];

    let onlyPromptOnce = function () {
        Message.error("您的账号存在异常，请重新登录！");
        onlyPromptOnce = function () {
        };
    };

    request.interceptors.response.use(
        (response) => {
            loading && loading.close();
            if (response.data.code === 200) {
                return response.data.data;
            } else {
                if (response.data.code === 419) {
                    CacheService.clear();
                    store.state.comp = "";
                    store.state.compList = [];
                    store.state.user = {};
                    store.state.menu = [];
                    store.state.auth = [];
                    store.state.activeName = "";
                    onlyPromptOnce();
                    setTimeout(() => {
                        top.location = `${config.ssoUrl}/Acount/Logout?returnUrl=https:${config.localUrl}`;
                    }, 1000);
                } else {
                    Message.error(response.data.errormsg);
                    return Promise.reject(response.data.errormsg);
                }
            }
        },
        (error) => {
            loading && loading.close();
            const response = error.response;
            if (response.status === 401) {
                const user = TokenService.get();
                if (!isRefreshing && user) {
                    isRefreshing = true;
                    request.get(`Yunos/User/RefreshToken?refreshToken=${encodeURIComponent(user.refreshToken)}`).then((res) => {
                            isRefreshing = false;
                            if (res.accessToken) {
                                TokenService.set({...user, ...res});
                                request.defaults.headers.common.Authorization = `Bearer ${res.accessToken}`;
                                refreshSubscribers.forEach((cb) => cb(res.accessToken));
                                refreshSubscribers = [];
                            }
                        }, () => {
                            isRefreshing = false;
                            Message.error("登录信息失效,请重新登录");
                            CacheService.clear();
                            request.get(`/Yunos/User/ApplySecret?applyIdDto=10000001`).then((res) => {
                                // alert(config.localUrl);
                                top.location = `${config.ssoUrl}/Acount/Authlogin?clientId=10000001&clientSecret=${res.applySecret}&redirect=${config.localUrl}&timespan=${res.timeStamp}`;
                            });
                        }
                    );
                }
                let retry = new Promise((resolve, reject) => {
                    refreshSubscribers.push((token) => {
                        response.config.headers.Authorization = "Bearer " + token;
                        request(response.config).then((res) => {
                            resolve(res);
                        });
                    });
                });
                return retry;
            } else if (response.status == 402) {
                Message.error("没有权限");
                return Promise.reject(error);
            } else if (response.status === 403) {
                Message.error("暂无权限，请联系管理员授权");
                return Promise.reject(error);
            } else {
                Message.error("请求失败，请重试");
                return Promise.reject(error);
            }
        }
    );

    Plugin.install = function (Vue, options) {
        Vue.axios = request;
        window.axios = request;
        Object.defineProperties(Vue.prototype, {
            axios: {
                get() {
                    return request;
                },
            },
            $axios: {
                get() {
                    return request;
                },
            },
        });
    };
    // Vue.prototype.axios = request
    Vue.use(Plugin);
}

export default request;
